import { render } from "./Gis.vue?vue&type=template&id=4cead4da"
const script = {}

import exportComponent from "/var/www/distan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__